import { PageHero } from "../components/common/PageHero";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export function NotFoundPage() {
  useDocumentMeta({
    canonicalPath: "/404",
    description: "The requested page could not be found.",
    title: "Not Found | Holocron Security"
  });

  return (
    <PageHero
      actions={[{ href: "/", label: "Return Home", variant: "primary" }]}
      copy="The requested route does not exist in the current control-plane experience."
      eyebrow="404"
      title="Page not found."
    />
  );
}
